import { SgovAdapter } from "@dataspecer/sgov-adapter";
import { CimAdapterWrapper } from "../v1-adapters/cim-adapter-wrapper.js";
import { ExternalSemanticModel } from "./external-semantic-model.js";
import { SimpleAsyncQueryableObservableEntityModel } from "../../entity-model/async-queryable/implementation.js";
class IdentityIriProvider {
    cimToPim = (cimIri) => cimIri;
    pimToCim = (pimIri) => pimIri;
}
export function createSgovModel(endpoint, httpFetch, id) {
    const adapter = new SgovAdapter("https://slovník.gov.cz/sparql", httpFetch);
    adapter.setIriProvider(new IdentityIriProvider());
    const queryableWrapper = new CimAdapterWrapper(adapter);
    const observableWrapper = new SimpleAsyncQueryableObservableEntityModel(queryableWrapper);
    return new ExternalSemanticModel(queryableWrapper, observableWrapper, id);
}
//# sourceMappingURL=sgov-model.js.map